import React, { useEffect, useState, type FormEvent } from "react";
import type { NodeProps, Node } from "@xyflow/react";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import type { SetStationaryRelayData } from "../../../api";
import { StationaryRelay } from "../../../api";
import type { IChoiceGroupOption } from "@fluentui/react";
import { ChoiceGroup } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

type SetStationaryRelayNode = Node<InterfaceToRecord<SetStationaryRelayData & ExtraNodeData>>;

export default function SetStationaryRelay(props: NodeProps<SetStationaryRelayNode>): JSX.Element {
    const { t } = useTranslation();
    const [selectedStationaryRelay, setSelectedStationaryRelay] = useState(
        props.data.relay ?? StationaryRelay.ONE,
    );
    const relayOptions: IChoiceGroupOption[] = Object.values(StationaryRelay).map((key, index) => {
        return { key, text: t(`component.actionConfigNodes.relay.${index}`) };
    });

    const updateNode = useUpdateNodeData<SetStationaryRelayNode>(props.id);

    // We have to set the data to prevent undefined values
    useEffect(() => {
        updateNode({ relay: selectedStationaryRelay });
    }, [selectedStationaryRelay, updateNode]);

    function onChange(
        _e?: FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption,
    ): void {
        if (!option) {
            return;
        }
        setSelectedStationaryRelay(option.key as StationaryRelay);
    }

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <ChoiceGroup
                options={relayOptions}
                selectedKey={selectedStationaryRelay}
                onChange={onChange}
            />
        </ActionConfigNode>
    );
}
